import React, { Fragment } from 'react';

import {
    Button,
    Grid,
    Dialog,
    Typography,
    DialogContentText,
    DialogContent,
    DialogTitle,
    colors,
    DialogActions
} from '@material-ui/core';

const Alerts = ({ item, message, open, close, confirmation }) => {

    return (
        <Fragment>
            <Dialog aria-modal="true" open={open} 
                aria-labelledby="form-dialog-title2"
                aria-describedby="alert-dialog-description2">

                <DialogTitle id="form-dialog-title2">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        {message.title}
                    </Typography>
                </DialogTitle>

                <DialogContent dividers={true}>
                    <DialogContentText id="alert-dialog-description-info" style={{ color: colors.green[600] }} >
                        {message.info}
                    </DialogContentText>
                    <DialogContentText id="alert-dialog-description-warn" style={{ color: colors.red[600] }} >
                        <b>ATENÇÃO!</b> {message.warn}
                    </DialogContentText>

                    {(message.details) ?
                        message.details.map((detail, index) => (
                            <DialogContentText id={'alert-dialog-description-deetail' + index} style={{ marginLeft: 25, color: colors.red[600] }} >
                                {detail}
                            </DialogContentText>
                        )) : ''
                    }

                    <DialogContentText id="alert-dialog-description-msg">
                        {message.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid container
                        direction="row"
                        justify="flex-end"
                        alignItems="baseline"
                        spacing={2}  >
                        <Grid item >
                            <Button
                                color="secondary"
                                size="small"
                                type="submit"
                                variant="contained"
                                onClick={() => { confirmation(item) }}>
                                Sim
                                </Button>
                        </Grid>
                        <Grid item >
                            <Button
                                color="secondary"
                                size="small"
                                variant="contained"
                                onClick={() => { close() }}>
                                Não
                                </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};

export default Alerts;


